export default __webpack_public_path__ + "static/1-85e48a745c8e296cb3e259ebed6c07a7.jpg";